import 'client-only';
import { type TimeScalar, timeScalarToPlainString } from '../graphqlScalars';

/**
 * Parses a `TimeScalar` to a Date on the client *only*
 *
 * This is a **read/display** path: it does not create new types and does not add wire validation beyond `Date` parsing.
 */
export const timeScalarToDate = (value: TimeScalar): Date => {
  return new Date(timeScalarToPlainString(value));
};
